<script setup lang="ts">
import { Card, CardContent, CardHeader, CardTitle } from '../card'

defineProps<{
  title?: string
  data: {
    name: string
    color: string
    value: any
  }[]
  percentOfTotal?: number
}>()

function displayValue(value: unknown): string {
  const num = Number(value)
  if (Number.isNaN(num)) return String(value)
  return num.toLocaleString()
}

function displayPercent(value: number): string {
  const percent = value * 100
  const maximumFractionDigits = Math.abs(percent - Math.round(percent)) < 0.05 ? 0 : 1
  return new Intl.NumberFormat('en-US', {
    style: 'percent',
    maximumFractionDigits,
  }).format(value)
}
</script>

<template>
  <Card class="text-sm">
    <CardHeader v-if="title" class="p-3 border-b">
      <CardTitle>
        {{ title }}
      </CardTitle>
    </CardHeader>
    <CardContent class="p-3 min-w-[180px] flex flex-col gap-1">
      <div
        v-for="(item, key) in data"
        :key="key"
        class="flex justify-between"
      >
        <template v-if="percentOfTotal !== undefined && data.length === 1">
          <div class="flex items-center gap-2">
            <span class="w-2.5 h-2.5">
              <svg width="100%" height="100%" viewBox="0 0 30 30">
                <path
                  d=" M 15 15 m -14, 0 a 14,14 0 1,1 28,0 a 14,14 0 1,1 -28,0"
                  :stroke="item.color"
                  :fill="item.color"
                  stroke-width="1"
                />
              </svg>
            </span>
            <span class="font-semibold tabular-nums">{{ displayValue(item.value) }}</span>
          </div>
          <span class="text-muted-foreground tabular-nums">{{ displayPercent(percentOfTotal) }}</span>
        </template>
        <template v-else>
        <div class="flex items-center">
          <span class="w-2.5 h-2.5 mr-2">
            <svg width="100%" height="100%" viewBox="0 0 30 30">
              <path
                d=" M 15 15 m -14, 0 a 14,14 0 1,1 28,0 a 14,14 0 1,1 -28,0"
                :stroke="item.color"
                :fill="item.color"
                stroke-width="1"
              />
            </svg>
          </span>
          <span>{{ item.name }}</span>
        </div>
        <span class="font-semibold ml-4">{{ item.value }}</span>
        </template>
      </div>
    </CardContent>
  </Card>
</template>
